<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Productos",
            items: [
                {
                    text: "Home",
                    href: "/"
                },
                {
                    text: "productos",
                    active: true
                }
            ],
            productos:{},
            ingredientes:[],
            producto:null,
            isLoading:false,
            datos:{
                name:'',
                venta:0,
                ventax2:0,
                disponible:1,
                doble:0,
                ingredientes:[],
                ingredientesx2:[],
            },
            valor_editar:{}
        };
    },
    methods: {
        get_data(){
            this.isLoading=true
            try {
                axios.get('/api/productos').then(res=>{
                    this.productos = res.data.datos;
                    this.ingredientes = res.data.ingredientes;
                    this.$toasted.success('Datos cargados!');
                })  
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false
            }
        },
        agregar(){
            this.isLoading=true
            if(this.datos.doble){
                this.datos.ingredientesx2.concat(this.datos.ingredientes);
            }
            try {
                axios.post('/api/productos',this.datos).then(res=>{
                    if(res.data.estado){
                        this.producto = res.data.producto;
                        this.datos.name=''
                        this.get_data()
                    }else{
                        alert('error al agregar')
                    }
                    this.isLoading=false
                })
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false
            }
            this.datos.ingredientesx2=[]
        },
        editar_valor_producto(producto){
            this.valor_editar=producto
            this.$refs['editar_valor_producto'].show();
        },
        eliminar(id){
            this.isLoading=true
            axios.delete('/api/productos/'+id).then(res=>{
                this.productos = res.data.datos;
                this.get_data()
                this.isLoading=false
            })
        },
        guardar_valor(){
            if(this.valor_editar.name!=""){
                this.isLoading=true
                axios.put('/api/productos/'+this.valor_editar.id,this.valor_editar).then(res=>{
                    if(res.data.estado){
                        this.producto=res.data.producto
                        this.get_data()
                        this.isLoading=false    
                        this.$refs['editar_valor_producto'].hide();
                        this.valor_editar={}
                    }else{
                        Swal.fire({
                                //position: "top-end",
                                icon: "warning",
                                title: "Error al agregar",
                                text: '',
                                showConfirmButton: true,
                                timer: 5000
                            });
                    }
                    this.isLoading=false
                })
            }else{
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result)=>{
                    this.$refs['modal_producto'].show();
                })
            }
        },
    },
    mounted() {
        this.get_data()
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <b-modal id="editar_valor_producto" ref="editar_valor_producto" hide-footer>
                <template #modal-title>Editar {{ valor_editar.name }}</template>
                <div class="row justify-content-center">
                    <div class="col-md-12 col-lg-12 col-xl-12">
                        <!-- <img src="/images/Logo-Menu.png" alt class="img-fluid pb-3"/> -->
                        <div class="card overflow-hidden">
                            <div class="card-body pt-5">
                                <b-form-group id="input-group-122" label="Valor" label-for="input-122">
                                    <b-form-input id="input-122" v-model="valor_editar.venta"
                                        type="text">
                                    </b-form-input>
                                </b-form-group>
                                <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Disponible">
                                    <input type="checkbox" id="notify_stock_minimum" name="notify_stock_minimum" :true-value="1" :false-value="0" v-model="valor_editar.disponible">
                                </b-form-group>
                                <div class="row">
                                    <!-- Columna para x2 -->
                                    <div class="col-md-4">
                                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Doble?">
                                            <input type="checkbox" id="notify_stock_minimum" name="notify_stock_minimum" :true-value="1" :false-value="0" v-model="valor_editar.doble">
                                            x2
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Precio x2" v-if="valor_editar.doble">
                                            <b-form-input for="text" placeholder="Precio doble" v-model="valor_editar.ventax2"  ></b-form-input>
                                        </b-form-group>
                                    </div>
                                </div>
                                <button class="btn btn-success btn-sm py-2 px-4" @click="guardar_valor()">
                                    Guardar
                                </button>
                            </div>
                        </div>
                        <!-- end row -->
                    </div>
                    <!-- end col -->
                </div>
            </b-modal>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <th class="py-0 px-1">#</th>
                                <th class="py-0 px-1">NOMBRE</th>
                                <th class="py-0 px-1">VALOR</th>
                                <th class="py-0 px-1">X2</th>
                                <th class="py-0 px-1">VALORX2</th>
                                <th class="py-0 px-1">DISPONIBLE</th>
                                <th class="py-0 px-1"></th>
                            </thead>
                            <tbody>
                                <tr v-for="(m, i) in productos" :key="i">
                                    <td class="py-0 px-1">{{ i + 1 }}</td>
                                    <td class="py-0 px-1">{{ m.name }}</td>
                                    <td class="py-0 px-1">{{ m.venta }}</td>
                                    <td class="py-0 px-1">{{ m.doble==1?'Si':'No'  }}</td>
                                    <td class="py-0 px-1">{{ m.ventax2 }}</td>
                                    <td class="py-0 px-1">{{ m.disponible==1?'Si':'No' }}</td>
                                    <td class="py-0 px-1">
                                        <div class="btn-group">
                                            <button class="btn btn-success btn-sm py-1 px-2" title="Editar Valor" @click="editar_valor_producto(m)">
                                                <i class="fas fa-edit"></i>
                                            </button>
                                            <a @click="eliminar(m.id)" class="btn btn-danger btn-sm py-1 px-2">
                                                <i class="fas fa-trash"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Nombre">
                            <b-form-input for="text" placeholder="Nombre" v-model="datos.name"  ></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Precio">
                            <b-form-input for="text" placeholder="Precio" v-model="datos.venta"  ></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Disponible">
                            <input type="checkbox" id="notify_stock_minimum" name="notify_stock_minimum" :true-value="1" :false-value="0" v-model="datos.disponible">
                            Disponible
                        </b-form-group>
                        <div class="row">
                            <!-- Columna para x2 -->
                            <div class="col-md-4">
                                <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Doble?">
                                    <input type="checkbox" id="notify_stock_minimum" name="notify_stock_minimum" :true-value="1" :false-value="0" v-model="datos.doble">
                                    x2
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Precio x2" v-if="datos.doble">
                                    <b-form-input for="text" placeholder="Precio doble" v-model="datos.ventax2"  ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Columna para Ingredientes -->
                            <div class="col-md-4">
                                <b-form-group label-cols-sm="12" label="Ingredientes">
                                    <div v-for="ingrediente in ingredientes.filter(ingrediente => ingrediente.def.includes('Ingredientes'))" :key="ingrediente.id" class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="'ingredient' + ingrediente.id" :value="ingrediente.id" v-model="datos.ingredientes">
                                        <label class="form-check-label" :for="'ingredient' + ingrediente.id">
                                            {{ ingrediente.name }}
                                        </label>
                                    </div>
                                </b-form-group>
                            </div>

                            <!-- Columna para Bebestibles -->
                            <!-- <div class="col-md-4">
                                <b-form-group label-cols-sm="12" label="Bebestibles">
                                    <div v-for="ingrediente in ingredientes.filter(ingrediente => ingrediente.def=='Bebestible')" :key="ingrediente.id" class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="'ingredient' + ingrediente.id" :value="ingrediente.id" v-model="datos.ingredientes">
                                        <label class="form-check-label" :for="'ingredient' + ingrediente.id">
                                            {{ ingrediente.name }}
                                        </label>
                                    </div>
                                </b-form-group>
                            </div> -->
                            <!-- Columna para Agregados -->
                            <!-- <div class="col-md-4">
                                <b-form-group label-cols-sm="12" label="Agregados">
                                    <div v-for="ingrediente in ingredientes.filter(ingrediente => ingrediente.def=='Agregado')" :key="ingrediente.id" class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="'ingredient' + ingrediente.id" :value="ingrediente.id" v-model="datos.ingredientes">
                                        <label class="form-check-label" :for="'ingredient' + ingrediente.id">
                                            {{ ingrediente.name }}
                                        </label>
                                    </div>
                                </b-form-group>
                            </div> -->
                        </div>
                        <div class="row">
                            <!-- Columna para Ingredientes X2 (visible solo si datos.doble es true) -->
                            <div class="col-md-4" v-if="datos.doble">
                                <b-form-group label-cols-sm="12" label="X2">
                                    <div v-for="ingrediente in ingredientes.filter(ingrediente => ingrediente.def.includes('Ingredientesx2'))" :key="ingrediente.id" class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="'ingredient' + ingrediente.id" :value="ingrediente.id" v-model="datos.ingredientesx2">
                                        <label class="form-check-label" :for="'ingredient' + ingrediente.id">
                                            {{ ingrediente.name }}
                                        </label>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>
                        <b-button v-show="datos.name!=='' && datos.venta!==''" block variant="success" @click="agregar()">Agregar</b-button>
                        <loading-message v-if="isLoading" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>